import { Injectable } from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
declare var JSON: any;

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(
      private cookieService: CookieService,
  ) { }

  setUserId(id) {
    // this.cookieService.set('crewId', id);
    localStorage.setItem('crewId', id);
  }

  getUserId() {
    localStorage.getItem('crewId');
  }

  clearUserInfo() {
    localStorage.removeItem('token');
    this.cookieService.delete('token');

    localStorage.removeItem('expiryTime');
    localStorage.removeItem('proxyName');
    localStorage.removeItem('enableProxy');

    // localStorage.removeItem('crewId');
    // localStorage.removeItem('Zone');

    localStorage.removeItem('phone');
    localStorage.removeItem('userName');
    localStorage.removeItem('id');

    // localStorage.removeItem('defaultLang');
    // localStorage.clear();
    // localStorage.removeItem('currentUser');
    // localStorage.removeItem('inScenarioFlag');
    // localStorage.removeItem('currentScenario');
  }

  setItem(key, obj) {
    localStorage.setItem(key, JSON.stringify(obj));
  }

  getItem(key) {
    if (localStorage.getItem(key)) {
      return JSON.parse(localStorage.getItem(key));
    } else {
      return undefined;
    }
  }

  setLocalItem(name, data) {
    localStorage.setItem(name, JSON.stringify(data));
  }

  getLocalItem(name) {
    const itemString = localStorage.getItem(name);
    if (itemString) {
      return JSON.parse(itemString);
    } else {
      return undefined;
    }
  }
  removeLocalItem(item) {
    localStorage.removeItem(item);
  }
}
